import DropdownSelection from 'app/models/dropdown_selection';

export default DropdownSelection.extend({
  initialize({ initialChoice, apiModeSelection, collection }) {
    this.apiModeSelection = apiModeSelection;

    this.label = 'Warehouse';
    this.name = 'warehouse';
    this.initialChoice = initialChoice;
    this.collection = collection;
    this.setChoices();
    this.listenTo(this.collection, 'reset', this.setChoices);
  },
  setChoices() {
    if (this.collection.size() && this.collection.first().get('address')) {
      this.choices = this.collection.models.map(warehouse => ({
        option: warehouse.get('id'), readable: warehouse.get('address').cityState(),
      }));
    } else {
      this.choices = [{ option: null, readable: 'Loading...' }];
    }
    this.setCurrentChoice(this.initialChoice);
  },
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_warehouse_dropdown_selection.js